import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { request } from "../request/request";
import { APP_URL } from "../request/api";

const initialState = {
    imagePaths: [],
    loadingStatus: "idle",
    error: null
}

export const fetchVehiclesUpload = createAsyncThunk(
    "vehiclesUpload/fetchVehiclesUpload",
    async ({ token, id, files }, { rejectWithValue }) => {
        try {
            const formData = new FormData();

            files.forEach((file) => {
                formData.append("images[]", file);
            });

            const customHeaders = {
                Authorization: `Bearer ${token}`,
            };

            console.log("UPLOAD ID:", id, "URL:", `${APP_URL}/images/vehicles/${id}`);


            const response = await request(
                `${APP_URL}/images/vehicles/${id}`,
                "POST",
                formData,
                customHeaders,
                "omit"
            );

            return response;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

const vehicleImageSlice = createSlice({
    name: 'vehiclesUpload',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchVehiclesUpload.pending, (state) => {
                state.imagePath = [];
                state.loadingStatus = "loading";
                state.error = null;
            })
            .addCase(fetchVehiclesUpload.fulfilled, (state, action) => {
                state.imagePaths = action.payload.image_path || [];
                state.loadingStatus = "idle";
                state.error = null;
            })
            .addCase(fetchVehiclesUpload.rejected, (state, action) => {
                state.imagePath = [];
                state.loadingStatus = "error";
                state.error = action.payload;
            })
    }
});

export default vehicleImageSlice.reducer;

